import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  ModalClose,
  ModalDialog,
  Typography,
} from "@mui/joy";
import { ApiVenueColor } from "griptonite-api-client";

import { useCurrentVenueUuid, useDeleteVenueColorMutation } from "@/hooks/venues";

import { useModal } from "./useModal";

export default function ConfirmDeleteVenueColor({ color }: { color: ApiVenueColor }) {
  const { close } = useModal();
  const venueUuid = useCurrentVenueUuid();
  const mutation = useDeleteVenueColorMutation(venueUuid);

  const onConfirm = () =>
    mutation.mutate(color.uuid, {
      onSuccess: () => {
        close();
      },
      onError: () => {
        alert("Failed to delete color. Please try again or contact support");
      },
    });

  return (
    <ModalDialog>
      <ModalClose />
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>
        <Typography sx={{ maxWidth: 400 }}>
          Do you want to delete this color from the palette?
        </Typography>
        <Typography sx={{ maxWidth: 400 }} level="body-sm" textColor="neutral.600">
          Note that it will not be removed from gym routes - only from the gym color palette.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          color="danger"
          onClick={() => {
            onConfirm();
          }}
          sx={{ flex: 1 }}
          loading={mutation.isPending}
        >
          Continue
        </Button>
        <Button color="neutral" variant="soft" onClick={close} sx={{ flex: 1 }}>
          Cancel
        </Button>
      </DialogActions>
    </ModalDialog>
  );
}
